export type TRequiredEventProperties = {
  // Required for all events https://www.notion.so/glossgeniusteam/Implementation-of-Track-Event-Type-bdfd698b543d431a8c1eed7f6b73bc29
  product_area: string;
  platform_name: string;

  // Required for all booking site events - set at runtime
  clientToken?: string;
  businessId?: string;
  business_owner_user_guid?: string;
  theme_name?: string;
  referrer?: string;
};

export enum BookingFlowType {
  SERVICE_FIRST = 'service_first',
  PROFESSIONAL_FIRST = 'professional_first',
}

/**
 * @deprecated The type should not be used
 */
export interface TLegacyEventProperties {
  actor: string;
  platformContext: string;

  action: string;
  productSection: string;
  objectType: string;
  productSubSection: string;
}

/**
 * @deprecated The type should not be used
 */
export enum EventAction {
  SELECT = 'Select',
  VIEW = 'View',
  ADD = 'Add',
  SUCCESS = 'Success',
  PAY = 'Pay',
}

/**
 * @deprecated The type should not be used
 */
export enum EventObjectType {
  BUTTON = 'Button',
  PAGE = 'Page',
  WAITLIST_DATA = 'Waitlist Data',
  CHECKBOX = 'Checkbox',
}
